import quickSpecs from './quickSpecs';
import vehicleType from './vehicleType';
import attributesFromIDC from './attributesFromIDC';
import isElectric from './isElectric';

const root = {
	quickSpecs,
	vehicleType,
	attributesFromIDC,
	isElectric
};

export default root;
